import {numberGtRegExp, numberLtRegExp, numberRangeRegExp, numberRegExp} from './number.parser';
import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryGreaterEqual, buildQueryLessEqual} from '../../query/elastic.queries';

export interface FrequencyProperties {
  readonly path: string;
  readonly frequencyMin: string;
  readonly frequencyMax: string;
}

const maxAlmaFrequency = 1000;
const minAlmaFrequency = 0;

export class FrequencyParser implements ElasticParser {
  parseValue(frequenciesString: string, elasticSearchProperty: ElasticSearchProperty): any {
    const property: FrequencyProperties = elasticSearchProperty.property;

    const frequenciesQueries = frequenciesString?.split('|')
      .map(frequencyString => frequencyString.trim())
      .filter(frequencyString => !!frequencyString)
      .map(frequencyString => {
        const isFrequencyStringANumber = numberRegExp.test(frequencyString);
        const isFrequencyStringARangeNumber = numberRangeRegExp.test(frequencyString);
        const isFrequencyStringGtNumber = numberGtRegExp.test(frequencyString);
        const isFrequencyStringLtNumber = numberLtRegExp.test(frequencyString);

        if (isFrequencyStringANumber) {
          const from = buildQueryLessEqual(property.frequencyMin, +frequencyString);
          const to = buildQueryGreaterEqual(property.frequencyMax, +frequencyString);

          return {bool: {must: [from, to]}};
        } else if (isFrequencyStringARangeNumber) {
          const match = numberRangeRegExp.exec(frequencyString);
          const from = buildQueryLessEqual(property.frequencyMin, +match[6]);
          const to = buildQueryGreaterEqual(property.frequencyMax, +match[1]);

          return {bool: {must: [from, to]}};
        } else if (isFrequencyStringGtNumber) {
          const match = numberGtRegExp.exec(frequencyString);
          const from = buildQueryLessEqual(property.frequencyMin, maxAlmaFrequency);
          const to = buildQueryGreaterEqual(property.frequencyMax, +match[1]);

          return {bool: {must: [from, to]}};
        } else if (isFrequencyStringLtNumber) {
          const match = numberLtRegExp.exec(frequencyString);
          const from = buildQueryLessEqual(property.frequencyMin, +match[1]);
          const to = buildQueryGreaterEqual(property.frequencyMax, minAlmaFrequency);

          return {bool: {must: [from, to]}};
        } else {
          return undefined;
        }
      });

    const frequenciesQueriesDefined = frequenciesQueries?.filter(query => !!query).length > 0;

    if (frequenciesQueriesDefined) {
      return {bool: {should: frequenciesQueries}};
    } else {
      return undefined;
    }
  }
}
